import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiBlobGetRequest,
} from '../../api';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Pengiriman',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Pembelian',
        href: '/adm/purchase-delivery',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_purchase',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'created_at',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'code_pd',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'dist_name',
        label: 'Distributor',
        sortable: true,
      },
      {
        key: 'tgl_kirim',
        label: 'Tgl Kirim',
      },
      {
        key: 'code_purchase',
        label: 'Purhcase',
      },
      {
        key: 'no_trans',
        label: 'No Trans',
      },
      {
        key: 'nopol',
        label: 'Nopol',
      },
      {
        key: 'total_do',
        label: 'Total',
      },
      {
        key: 'point',
        label: 'Point',
      },
      {
        key: 'status_pay',
        label: 'Pembayaran',
      },
      {
        key: 'status_pd',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
        thStyle: {
          width: '100px',
        },
      },
    ],
    detail: false,
    form: {},
    import_form: [],
    member: '',
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  detail(state) {
    return state.data.detail;
  },
};

export const mutations = {
  changePurchaseDelivery(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchPurchase(context, params = null) {
    let result = await ApiGetRequest(
      `purchase-delivery/search-purchase`,
      params
    );
    return !result.error ? result.data.object : [];
  },

  async searchArmada(context, params = null) {
    let result = await ApiGetRequest(`armada`, params);
    return !result.error ? result.data.object : [];
  },

  async getListPurchaseDelivery({ commit, state }, payload = {}) {
    commit('changePurchaseDelivery', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_distributor: data.id_distributor ? data.id_distributor : '',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
      member: data.member,
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`purchase-delivery`, params);
      commit('changePurchaseDelivery', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_purchase.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`purchase-delivery`, params);
      commit('changePurchaseDelivery', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailPurchaseDelivery({ commit }, payload = null) {
    commit('changePurchaseDelivery', {
      loading: true,
    });

    let result = await ApiGetRequest(`purchase-delivery/${payload.id}`);
    commit('changePurchaseDelivery', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async createPurchaseDelivery({ commit, state, dispatch }) {
    commit('changePurchaseDelivery', {
      loading: true,
    });

    let result = await ApiPostRequest(`purchase-delivery`, state.data.form);
    commit('changePurchaseDelivery', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updatePurchaseDelivery({ commit, state, dispatch }, payload = null) {
    commit('changePurchaseDelivery', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `purchase-delivery/${payload.id}`,
      state.data.form
    );

    commit('changePurchaseDelivery', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deletePurchaseDelivery({ commit, dispatch }, payload = null) {
    commit('changePurchaseDelivery', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`purchase-delivery/${payload.id}`);
    commit('changePurchaseDelivery', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
